import React from 'react';

import MultiOutcome from '../outcomes/MultiOutcome.jsx';
import SlotName from './SlotName.jsx';

export default class MultiOutcomeSlot extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        sportId: React.PropTypes.number.isRequired,
        match: React.PropTypes.object,
        slot: React.PropTypes.object.isRequired,
        outcomes: React.PropTypes.array.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    static renderOutcome(outcome, section, gridLocalization) {
        const id = outcome.get('id');
        return (<MultiOutcome key={id} outcome={outcome} section={section} gridLocalization={gridLocalization} />);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.gridLocalization !== nextProps.gridLocalization ||
            this.props.slot !== nextProps.slot ||
            this.props.outcomes !== nextProps.outcomes;
    }

    render() {
        const {section, sportId, match, slot, outcomes, gridLocalization} = this.props;

        const slotNameProps = {
            sportId,
            match,
            slot,
            outcome: outcomes[0],
            gridLocalization
        };

        return (
            <div className="table detailed">
                <div className="row inner">
                    <div className="cell main">
                        <SlotName {...slotNameProps}/>
                    </div>

                    <div className="cell rate multi">
                        {outcomes.map((o) => MultiOutcomeSlot.renderOutcome(o, section, gridLocalization))}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/slots/MultiOutcomeSlot.jsx